module.exports = __webpack_public_path__ + "static/media/desktop17.e5124f39.png";